import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer } from "react-toastify";
import Pagination from "../Common/Pagination";
import moment from "moment";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NewGatWiseBillAnalysis = () => {
  const navigate = useNavigate();
  const userState = useSelector(state => state?.loginData?.userData);
  const financialYear = useSelector((state) => state.activeData.financialYear);
  const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState();
  const [zoneList, setZoneList] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");

  // States for Pagination ----------
  const [pageNo, setPageNo] = useState(1);
  const [docPerPage, setDocPerPage] = useState(50);

  const requestRef = useRef(0);
  const prevYearRef = useRef(financialYear);

  useEffect(() => {
    getZoneList();
  }, []);

  useEffect(() => {
    const isYearChanged = prevYearRef.current !== financialYear;

    if (isYearChanged) {
      if (financialYear === "2023-2024") {
        navigate("/dashboard");
        return;
      } else {
        setSelectedZone("");
        setPageNo(1);
        setData();
        prevYearRef.current = financialYear;
        getZoneList(); 
        return;       
      }
    }

   const isAdmin = userState?.usertype_keyname?.includes("admin");
    const isZonalOfficer = userState?.usertype_keyname?.includes("zonalofficer");
    const isSupervisor = userState?.usertype_keyname?.includes("supervisor");

    if (isZonalOfficer || isSupervisor) {
      getGatWiseListData();
    } else if (isAdmin && selectedZone) {
      getGatWiseListData(selectedZone);
    }

  }, [selectedZone, financialYear]);

  const getZoneList = async () => {
    await fetch(process.env.REACT_APP_BASE_URL + "/zoneData/getZoneData", {
      method: "GET",
    })
      .then((res) => res.json())
      .then((response) => {
        setZoneList(response.data);
        if (response.data.length > 0) {
          setSelectedZone(response.data[0].zonename);
        }
      })
      .catch((err) => {
        console.log("err while getting zone=>", err);
      });
  };

  const getGatWiseListData = async (sZone = selectedZone) => {
    const requestId = ++requestRef.current;
    setLoader(true);
    try {
      const res = await fetch(
        process.env.REACT_APP_BASE_URL + "/billDistribution/getZonewiseGatCount",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...(userState?.usertype_keyname?.includes("admin") && {
              zonename: sZone,
            }),
            ...(userState?.usertype_keyname?.includes("zonalofficer") && {
              zonekey: userState?.zonekey,
            }),
            financialYear: financialYear,
          }),
        }
      );
      const response = await res.json();

      if (requestId !== requestRef.current) return;

      if (response.status === 200) {
        setData(response);
      } else {
        setData();
      }
    } catch (error) {
      if (requestId === requestRef.current) {
        setData();
      }
    } finally {
      if (requestId === requestRef.current) {
        setLoader(false);
      }
    }
  };

  return (
    <div className="visitReport">
      <ToastContainer />
      <Container>
        <Row>
          {userState?.usertype_keyname?.includes("admin") &&
            <Row className="justify-content-center mb-3">
              <Col md={4} className="searchCard">
                <div className="label mb-2 mx-auto">
                  <p>Search by zone</p>
                </div>
                <div className="d-flex mt-1">
                  <Form.Select value={selectedZone} onChange={(e) => setSelectedZone(e.target.value)}>
                    <option value="" disabled>
                      Select zone
                    </option>
                    {zoneList !== undefined && zoneList.length > 0 && zoneList !== null ? (
                      zoneList?.map((row) => {
                        return (
                          <option key={row?.zonekey} value={row?.zonename}>
                            {row?.zonename + "-" + row?.zoneno}
                          </option>
                        );
                      })
                    ) : (
                      <option value=""></option>
                    )}
                  </Form.Select>
                </div>
              </Col>
            </Row>
          }

          <div className="container tbl-container p-0">
            <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
              <Table responsive="lg" hover style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th colSpan="6" className="text-center border-th">
                      Current Year
                    </th>
                  </tr>
                  <tr>
                    <th>Gat Name</th>
                    <th>Notice Count</th>
                    <th>Meeting Person Count</th>
                    <th>Mobile Verified Count</th>
                    <th>Property Not Found Count</th>
                    <th>Bill Issued Count</th>
                    <th className="border-th">Total Count</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : data?.data?.length > 0 ? (
                    data.data.map((row, index) => {
                      return (
                        <tr key={index}>
                          <td className="border-tr-new">{row?.gatname ? row?.gatname : "-"}</td>
                          <td className="border-tr-new">{row?.noticeCount ? row?.noticeCount : 0}</td>
                          <td className="border-tr-new">{row?.meetingPersonCount ? row?.meetingPersonCount : 0}</td>
                          <td className="border-tr-new">{row?.mobileVerifiedCount ? row?.mobileVerifiedCount : 0}</td>
                          <td className="border-tr-new">{row?.propertyNotFoundCount ? row?.propertyNotFoundCount : 0}</td>
                          <td className="border-tr-new">{row?.propertyFoundCount ? row?.propertyFoundCount : 0}</td>
                          <td className="border-tr">{row?.totalCount ? row?.totalCount : 0}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  {data !== undefined && data?.data?.length > 0 ? (
                    <tr className="sum-row">
                      <td colSpan="1" className="border-th-new">
                        <strong className="m-2">Total Counts :-</strong>
                      </td>
                      <td className="border-th-new">
                        <strong>{data?.totalNoticeCount ?? "0"}</strong>
                      </td>
                      <td className="border-th-new">
                        <strong>{data?.totalMeetingPersonCount ?? "0"}</strong>
                      </td>
                      <td className="border-th-new">
                        <strong>{data?.totalMobileVerifiedCount ?? "0"}</strong>
                      </td>
                      <td className="border-th-new">
                        <strong>{data?.totalPropertyNotFoundCount ?? "0"}</strong>
                      </td>
                      <td className="border-th">
                        <strong>{data?.totalPropertyFoundCount ?? "0"}</strong>
                      </td>
                      <td>
                        <strong>{data?.totalVisits ?? "0"}</strong>
                      </td>
                    </tr>
                  ) : null}
                </tfoot>
              </Table>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default NewGatWiseBillAnalysis;